import Step from './ThankYou';

export default Step;
